import React, { useState, useEffect } from "react";

import tw from "tailwind-styled-components";
import { Page, Underline } from "../../Components/Styles/PageStyles";
import { useSelector } from "react-redux";
import { useMutation, useQuery } from "react-query";
import axios from "axios";
import Config from "../../Config";
import { toast } from "react-toastify";
import Navbar from "../../Components/Navbar";
import First from "../../Components/Guidelines/first";
import Second from "../../Components/Guidelines/second";
import Third from "../../Components/Guidelines/third";
import Fourth from "../../Components/Guidelines/fourth";
import Fifth from "../../Components/Guidelines/fifth";
import Sixth from "../../Components/Guidelines/sixth";

import ServiceModel from "../../Components/Dashboard/ServiceModel";
import AnnualFeeModal from "../../Components/Applications/AnnualFeeModal";
import LostCertificateModal from "../../Components/Applications/LostCertificateModal";
import OtherServicesFeeModal from "../../Components/Dashboard/OtherServicesFeeModal";

import Images from "../../Images";
import { Link, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import moment from "moment";

const DashBoard = () => {
  const user = useSelector((state) => state.UserReducer.user);
  const [openUploadModel, setOpenUploadModel] = useState(false);
  const [openFeeModel, setOpenFeeModel] = useState(false);
  const [isFirstGuidelineOpen, setIsFirstGuidelineOpen] = useState(false);
  const [isSecondGuidelineOpen, setIsSecondGuidelineOpen] = useState(false);
  const [isThirdGuidelineOpen, setIsThirdGuidelineOpen] = useState(false);
  const [isFourthGuidelineOpen, setIsFourthGuidelineOpen] = useState(false);
  const [isFifthGuidelineOpen, setIsFifthGuidelineOpen] = useState(false);
  const [isSixthGuidelineOpen, setIsSixthGuidelineOpen] = useState(false);

  const { t, i18n } = useTranslation();
  const [selectedLang, setActiveLang] = useState(i18n.language || "");

  const [openOtherServicesFeeModal, setOpenOtherServicesFeeModal] =
    useState(false);
  const [openLostCertificateModel, setOpenLostCertificateModel] =
    useState(false);
  const navigate = useNavigate();
  const [firstTitle, setFirstTitle] = useState("");
  
  const toggleFirstGuideline = () =>
    setIsFirstGuidelineOpen(!isFirstGuidelineOpen);

  const toggleSecondGuideline = () =>
    setIsSecondGuidelineOpen(!isSecondGuidelineOpen);

  const toggleThirdGuideline = () =>
    setIsThirdGuidelineOpen(!isThirdGuidelineOpen);
  
  const toggleFourthGuideline = () =>
    setIsFourthGuidelineOpen(!isFourthGuidelineOpen);

  const toggleFifthGuideline = () =>
    setIsFifthGuidelineOpen(!isFifthGuidelineOpen);

  const toggleSixthGuideline = () =>
    setIsSixthGuidelineOpen(!isSixthGuidelineOpen);

  const [startDate, setStartDate] = useState(
    moment(new Date()).format("YYYY-MM-DD")
  );

  const [endDate, setEndDate] = useState(
    moment(new Date()).format("YYYY-MM-DD")
  );

  const fetchFunction = async (values) => {
    //console.log("In fetchFunction");
    const body = new FormData();
    body.append("token", user.id);
    body.append("userType", user.userType);
    body.append("startDate", startDate);
    body.append("endDate", endDate);

    return await axios.post(`${Config.apiUrl}/dashboard`, body, {
      headers: {
        authorization: user.token,
        "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
      },
    });
  };

  const onSuccess = (data) => {
    setFirstTitle(t("Application_Registration"));
    // if (data.data.data.association == "0")
    //   setFirstTitle ("Application For Registration");
    // else
    //   setFirstTitle ("My Applications");
    //console.log(data.data.data.addresschange);
  };

  const onError = (error) => console.log("error", error.response);

  const { isLoading, error, data, refetch } = useQuery(
    "dashboardData",
    fetchFunction,
    {
      onSuccess,
      onError,
    }
  );

  const openServicesModel = (e) => {
    setOpenUploadModel(true);
  };

  const downloadFirstLaw = (e) => {
    window.open(Config.domain + "/download/SAMPULI_YA_KATIBA_ZA_MICHEZO.pdf", "_blank");
  };

  const downloadSecondLaw = (e) => {
    window.open(Config.domain + "/download/KANUNI_ZA_TAASISI_ZA_MICHEZO.pdf", "_blank");
  };

  const openLosCertificateModel = (e) => {
    setOpenLostCertificateModel(true);
  };

  const openOtherServicesFeeModel = (e) => {
    setOpenOtherServicesFeeModal(true);
  };

  const goToRegisterPage = (e) => {
    navigate("/registration");
  };

  const goToChangeOfCoPage = (e) => {
    navigate("/correct-const");
  };

  const goToChangeOfNamePage = (e) => {
    navigate("/change-name");
  };

  const goToChangeOfAddrPage = (e) => {
    navigate("/change-address");
  };

  const goToChangeOfArticlePage = (e) => {
    navigate("/change-article");
  };

  const gotToAssociationPage = (e) => {
    navigate("/my-association");
  };

  const goToCorrectionForm = (e) => {
    navigate("/correct-const");
  };

  const LostCertificatePostFunction = async (values) => {
    
    const body = new FormData();
    body.append("customerId", user.id);
    body.append("email", user.email);
    body.append("userType", user.userType);
    body.append("assocName", values.assocName);
    body.append("assocId", values.assocId);
    body.append("fees", values.fees);
    return await axios.post(`${Config.nodeApiUrl}/lostcertificate`, body, {
      headers: {
        authorization: user.token,
        "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
      },
    });
  };

  const onLostCertificateSuccess = (res) => {
    setOpenLostCertificateModel(false);
    toast.success(res?.data?.msg || "Success");
  };

  const onLostCertificateError = (res) => {
    setOpenLostCertificateModel(false);
    toast.error(res?.response?.data?.msg || "An Error Occured");
  };

  const { isLoading: SingleEntryLoading, mutate: postLostCertificateMutate } =
    useMutation(LostCertificatePostFunction, {
      onSuccess: onLostCertificateSuccess,
      onError: onLostCertificateError,
    });

  return (
    <>
      <Navbar />
      <Page>
        {openUploadModel && (
          <ServiceModel
            setOpenUploadModel={setOpenUploadModel}
            data={data?.data}
          />
        )}

        {openFeeModel && <AnnualFeeModal setOpenFeeModel={setOpenFeeModel} />}

        {openOtherServicesFeeModal && (
          <OtherServicesFeeModal
            setOpenOtherServicesFeeModal={setOpenOtherServicesFeeModal}
          />
        )}

        {openLostCertificateModel && (
          <LostCertificateModal
            setOpenLostCertificateModel={setOpenLostCertificateModel}
            postLostCertificateMutate={postLostCertificateMutate}
          />
        )}

        <Container>
          <Title>{t("Welcome")} {user.fname} </Title>

          <p className="text-sm text-gray-400 mt-10">
            {t("Please_choose")}
          </p>

          <Flex>
            <CardWrapper>
              <SingleCard
                title={t("Application_Registration")}
                bg="bg-orange-500 text-white "
                // icon={
                //   <img
                //     src={Images.Create}
                //     alt="icon"
                //     className="w-16 sm:w-24"
                //   />
                // }
                onclick={goToRegisterPage}
              />
              {/* <SingleCard
                title="Changing of Particulars"
                bg="bg-blue-400 text-white "
                icon={
                  <img
                    src={Images.Create}
                    alt="icon"
                    className="w-16 sm:w-24"
                  />
                }
                onclick={openServicesModel}
              /> */}
              {/* <SingleCard
                title= {t("My_Associations")}
                bg="bg-orange-500 text-white "
                onclick={gotToAssociationPage}
              /> */}
              
              <SingleCard
                title={t("Correcting_Constitution")}
                bg="bg-cyan-700 text-white "
                onclick={goToChangeOfCoPage}
              />
              <SingleCard
                title={t("Change_Article")}
                bg="bg-orange-500 text-white "
                onclick={goToChangeOfArticlePage}
              />
              <SingleCard
                title={t("Change_Name")}
                bg="bg-cyan-700 text-white "
                onclick={goToChangeOfNamePage}
              />
              <SingleCard
                title={t("Change_Address")}
                bg="bg-orange-500 text-white "
                onclick={goToChangeOfAddrPage}
              />
            </CardWrapper>

            <GuidelinesWrapper>
              <div className="flex w-full justify-between items-center">
                <div className="w-full">
                  <GuidelineTitle>
                    UTARATIBU WA KUSAJILI CHAMA / KLABU NA MABADILIKO YA VIFUNGU
                    VYA KATIBA ZA VYAMA VYA MICHEZO
                  </GuidelineTitle>
                  <Underline />
                  {/* Start of first guideline */}
                  <ToggleButton onClick={toggleFirstGuideline}>
                    <ButtonTitle>1. UTARATIBU WA KUSAJILI </ButtonTitle> <Line />
                    <img
                      src={Images.Arrow}
                      alt="Arrow"
                      className={`${isFirstGuidelineOpen ? "rotate-90" : "-rotate-90"} w-2`}
                    />
                  </ToggleButton>
                  {isFirstGuidelineOpen && (
                    <First
                    />
                  )}

                  {/* Second Guideline */}
                  <ToggleButton onClick={toggleSecondGuideline}>
                    <ButtonTitle>2. SIFA ZA KATIBA ZA VYAMA VYA MICHEZO </ButtonTitle> <Line />
                    <img
                      src={Images.Arrow}
                      alt="Arrow"
                      className={`${isSecondGuidelineOpen ? "rotate-90" : "-rotate-90"} w-2`}
                    />
                  </ToggleButton>
                  {isSecondGuidelineOpen && (
                    <Second
                    />
                  )}
                  {/* End Second Guideline */}

                  {/* Third Guideline */}
                  <ToggleButton onClick={toggleThirdGuideline}>
                    <ButtonTitle>3. MAREKEBISHO YA KATIBA </ButtonTitle> <Line />
                    <img
                      src={Images.Arrow}
                      alt="Arrow"
                      className={`${isThirdGuidelineOpen ? "rotate-90" : "-rotate-90"} w-2`}
                    />
                  </ToggleButton>
                  {isThirdGuidelineOpen && (
                    <Third
                    />
                  )}
                  {/* End Third Guideline */}
                  <GuidelineTitle>
                    VIGEZO VYA KUSAJILI AKADEMIA, KITUO NA KLABU ZA MICHEZO
                  </GuidelineTitle>
                  <Underline />
                  {/* Fourth Guideline */}

                  <ToggleButton onClick={toggleFourthGuideline}>
                    <ButtonTitle>AKADEMIA (SHULE) YA MICHEZO </ButtonTitle> <Line />
                    <img
                      src={Images.Arrow}
                      alt="Arrow"
                      className={`${isFourthGuidelineOpen ? "rotate-90" : "-rotate-90"} w-2`}
                    />
                  </ToggleButton>
                  {isFourthGuidelineOpen && (
                    <Fourth
                    />
                  )}
                  {/* End Fourth Guideline */}

                  {/* Fifth Guideline */}
                  <ToggleButton onClick={toggleFifthGuideline}>
                    <ButtonTitle>KITUO CHA MICHEZO</ButtonTitle> <Line />
                    <img
                      src={Images.Arrow}
                      alt="Arrow"
                      className={`${isFifthGuidelineOpen ? "rotate-90" : "-rotate-90"} w-2`}
                    />
                  </ToggleButton>
                  {isFifthGuidelineOpen && (
                    <Fifth
                    />
                  )}
                  {/* End Fifth Guideline */}

                  {/* Sixth Guideline */}
                  <ToggleButton onClick={toggleSixthGuideline}>
                    <ButtonTitle>KLABU ZA MICHEZO </ButtonTitle> <Line />
                    <img
                      src={Images.Arrow}
                      alt="Arrow"
                      className={`${isSixthGuidelineOpen ? "rotate-90" : "-rotate-90"} w-2`}
                    />
                  </ToggleButton>
                  {isSixthGuidelineOpen && (
                    <Sixth
                    />
                  )}
                  {/* End Sixth Guideline */}
                </div>
              </div>
            </GuidelinesWrapper>
          </Flex>
        </Container>
      </Page>
    </>
  );
};

const SingleCard = ({ title, bg, icon, onclick }) => {
  return (
    <SingleCardWrapper $bg={bg} onClick={onclick}>
      {/* {icon} */}
      <p className="text-sm sm:text-base">{title}</p>
    </SingleCardWrapper>
  );
};

const Container = tw.div`Container`;
const Title = tw.h1`text-2xl md:text-3xl text-gray-900 mt-5  `;
const GuidelineTitle = tw.h1`text-lg md:text-xl text-cyan-700 mt-5 font-medium `;
const ButtonTitle = tw.h3`flex text-basic md:text-lg  text-gray-500 font-normal`;

const Flex = tw.div`flex flex-col lg:flex-row items-start lg:space-x-16`;
const CardWrapper = tw.div`mt-8 grid grid-cols-2  sm:grid-cols-3 gap-10 lg:gap-0 lg:flex lg:flex-col lg:space-y-10 mb-10 `;
const GuidelinesWrapper = tw.div`mb-10 border border-gray-200 rounded-lg w-full p-8 pt-3 mt-8 lg:-mt-24 `;
// const SingleCardWrapper = tw.div`
// ${(p) => p.$bg}
// p-4  h-44 w-36 sm:h-64 sm:w-52 rounded-lg  shadow-lg border border-gray-100 cursor-pointer  transition duration-200 flex flex-col justify-center space-y-5 items-center  hover:scale-95 transform hover:shadow-sm text-center`;

const SingleCardWrapper = tw.div`
${(p) => p.$bg}
p-4  h-15 w-36 sm:h-15 sm:w-52 rounded-lg  shadow-lg border border-gray-100 cursor-pointer  transition duration-200 flex flex-col justify-center space-y-5 items-center  hover:scale-95 transform hover:shadow-sm text-center`;

const SubmitBtnWrapper = tw.div`
mt-10 `;

const SubTitle = tw.h3`text-lg  text-gray-800   font-medium mt-4`;

const UploadWrapper = tw.div`
 w-full flex justify-end space-x-4 items-center `;

const Button = tw.button`text-white bg-teal-500 hover:bg-teal-600 w-40 flex items-center space-x-1 justify-center h-10   text-xs whitespace-nowrap rounded`;

const ToggleButton = tw.div`font-medium mt-8 cursor-pointer hover:bg-gray-50 p-3 rounded-md w-full flex items-center space-x-4`;


const Line = tw.div`grow shrink border-b-2 border-dashed border-gray-300 `;

export default DashBoard;
